import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from './Panel';
import './FormShell.css';
import './product-widgets-base.css';

/**
 * Onboarding / Auth-adjacent form card.
 * Same surface as Panel — sharp border, no shadow — plus form title/actions chrome.
 * layout: stack | address | twoCol — field grid variants
 * actionsAlign: start | center | end — form action row alignment
 */
export function FormShell({
  children,
  as = 'div',
  className = '',
  padded = true,
  layout = 'stack',
  actionsAlign = 'end',
  ...props
}) {
  return (
    <Panel
      as={as}
      padded={padded}
      className={[
        'onboarding-form',
        layout !== 'stack' ? `onboarding-form--layout-${layout}` : '',
        actionsAlign !== 'end' ? `onboarding-form--actions-${actionsAlign}` : '',
        className,
      ].filter(Boolean).join(' ')}
      data-testid="onyx-form-shell"
      data-layout={layout}
      data-actions-align={actionsAlign}
      {...props}
    >
      {children}
    </Panel>
  );
}

FormShell.propTypes = {
  children: PropTypes.node,
  as: PropTypes.elementType,
  className: PropTypes.string,
  padded: PropTypes.bool,
  layout: PropTypes.oneOf(['stack', 'address', 'twoCol']),
  actionsAlign: PropTypes.oneOf(['start', 'center', 'end']),
};

export default FormShell;
